import { useT } from "@transifex/react";
import { Accordion } from "storybook/components/accordion";
import { Checkbox } from "storybook/components/checkbox";
import { AccordionContents, AccordionDetails, ContentWrapper } from "../styles";

type Props = {
  content: React.ReactNode;
};

export const GeneticTestingAccordion = ({ content }: Props) => {
  const t = useT();

  return (
    <Accordion
      theme="default"
      initialExpanded={Boolean(content)}
      ariaLabel={t("Genetic Testing")}
      title={
        <AccordionDetails>
          <Checkbox
            size="medium"
            hideDirty={true}
            theme="patient-facing"
            label={t("Genetic Testing")}
            name="screenings.geneticTesting"
          />
          <div></div>
        </AccordionDetails>
      }
    >
      {content ? (
        <AccordionContents>
          <ContentWrapper>
            <div role="article" className="notranslate">
              {content}
            </div>
          </ContentWrapper>
        </AccordionContents>
      ) : null}
    </Accordion>
  );
};
